module.exports = __webpack_public_path__ + "media/images/official/about_yamori_shinano-45c1cb42e714b554e6db0a8f35387fa3.png";